export default "__VITE_ASSET__DnbERNE0__"